import {FieldErrorTypes,ActionErrorType} from './ValidationType';


export const initialValidState:FieldErrorTypes= {

   //MonthDate: new Date(now.getFullYear(), now.getMonth() - 1, 1),

    
    ProjectManagersMessage:'',

    TlRatingMessage:'',

    PMRatingMessage:'',

    FMRatingMessage:'',

    SelfRating:'',

    TLRemarkMessage:'',

    SelfRemarkMessage: '',

    ProjectManagerRemarkMessage:'',

    FinalManagerRemarkMessage:'',
  
};



export const Errorreducer = (state: FieldErrorTypes, action: ActionErrorType): FieldErrorTypes => {
  
    switch (action.type) {
      
      case 'SET_REMARKError':
            
       return { ...state, SelfRemarkMessage:action.payload };

       case 'SET_TLREMARKError':
            
       return { ...state, TLRemarkMessage:action.payload };

       case 'SET_ProjectManagerRemarkError':
            
       return { ...state, ProjectManagerRemarkMessage:action.payload };

       case 'SET_RMRemarkError':
            
       return { ...state, FinalManagerRemarkMessage:action.payload };

       case 'SET_MANAGERSError':
            
       return { ...state, ProjectManagersMessage:action.payload };
        
       case 'SET_RATINGError':
        return { ...state, SelfRating:action.payload};

        case 'SET_TLRATINGError':
        return { ...state, TlRatingMessage:action.payload};
         
        case 'SET_PMRATINGError':
        return { ...state, PMRatingMessage:action.payload};    

        case 'SET_RMRATINGError':
        return { ...state, FMRatingMessage:action.payload};
        
      default:
        return state;
    }
  };